import {Injectable, inject} from '@angular/core';
import {ToastComponent, ToastUtility} from "@syncfusion/ej2-angular-notifications";
import {TYPE} from "../types/types";
import {LanguageService} from "./language.service";

@Injectable({
  providedIn: 'root'
})
export class ToasterService {
  private languageService: LanguageService = inject(LanguageService);

  private defaultTimeOut: number = 5000;
  private toastObj: ToastComponent | null = null;

  private showToast(title: string, message: string, cssClass: string, options?: { timeOut?: number; showCloseButton?: boolean; buttonText?: string; onButtonClick?: () => void; link?: string }): ToastComponent {
    const timeOut = options?.timeOut ?? this.defaultTimeOut;
    const showCloseButton = options?.showCloseButton ?? false;
    const buttonText = options?.buttonText ?? 'Close';
    const linkTemplate = (options?.link !== undefined && options?.link.trim() !== '') ?
      `<a
        target="_blank"
        href="${options!.link}"
        class="nav-link px-2 pb-2 text-primary"
        >${this.languageService.getTranslationByKey('TOASTFURTHERINFORMATIONLINK')}
      </a>`:
      '';

    const showCloseActionButton = timeOut === 0;

    this.toastObj = ToastUtility.show({
      title,
      content: `
      <div class="d-flex flex-column align-items-center">
        <div class="d-flex align-items-center p-2">
          <span class="mts-icon pe-2 fs-4">
          </span>
          <div class="flex-grow-1 text-wrap">
            ${message}
          </div>
        </div>
        ${linkTemplate}
      </div>
      `,
      width: 'auto',
      timeOut,
      animation: {show: {effect: 'SlideRightIn'}, hide: {effect: 'SlideRightOut'}},
      position: {X: 'Right', Y: 'Top'},
      newestOnTop: true,
      showCloseButton,
      cssClass,
      buttons: showCloseActionButton ? [{
        model: {content: buttonText},
        click: options?.onButtonClick ?? this.toastClose.bind(this)
      }] : []
    }) as ToastComponent;
    
    return this.toastObj;
  }

  public info(title: string, message: string, options?: Partial<Parameters<typeof this.showToast>[3]>): ToastComponent {
    return this.showToast(title, message, 'info', options);
  }

  public success(title: string, message: string, options?: Partial<Parameters<typeof this.showToast>[3]>): ToastComponent {
    return this.showToast(title, message, 'success', options);
  }

  public warning(title: string, message: string, options?: Partial<Parameters<typeof this.showToast>[3]>): ToastComponent {
    return this.showToast(title, message, 'warning', options);
  }

  public error(title: string, message: string, options?: Partial<Parameters<typeof this.showToast>[3]>): ToastComponent {
    return this.showToast(title, message, 'danger', options);
  }

  public reminder(reminder: TYPE.ReminderUpdate): void {
    if (!reminder) {
      return;
    }

    let label = this.languageService.getTranslationByKey('REMINDER');

    if (reminder.type === 'calendar') {
      label = this.languageService.getTranslationByKey('CALNEWUPCOMINGEVENT');
      const startsAt = new Date(reminder.payload.dateStart);
      reminder.description = this.languageService.getTranslationByKey('CALEVENTSTARTSAT') + '<b> ' + startsAt.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'}) + '</b>';
    }

    this.warning(
      label,
      '<strong>' + reminder.title + '</strong> ' + reminder.description,
      {
        timeOut: 0,
        showCloseButton: true,
        buttonText: this.languageService.getTranslationByKey('VIEW'),
        onButtonClick: () => this.openReminder(reminder)
      }
    );
  }

  public toastClose(): void {
    this.toastObj?.hide();
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public openReminder(reminder: TYPE.ReminderUpdate): void {
    // TODO: Implement the logic to open the reminder details
  }
}
